import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import type { UniDriver } from '@wix/unidriver-core';

export const drawerDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};

export type DrawerUniDriver = ReturnType<typeof drawerDriverFactory>;
